<template>
  <div>
    <Header
      :headerTitle="$t('m.invoicingInfo.title')"
      :hasBackBtn="true"
      :rightIconSrc="require('../../assets/img/dianhua.png')"
      :onRightBtnClick="call"
      :iconShow="true"
    ></Header>
    <header>
      <div class="warning">
        <b-alert show variant="warning">{{$t('m.invoicingInfo.topTips')}}</b-alert>
      </div>
      <div class="invocingInfoTitle">{{$t('m.invoicingInfo.subtitle1')}}</div>
      <ul>
        <li>
          <strong style="padding-top:12px !important;">{{$t('m.invoicingInfo.typeTitle')}}</strong>
          <b-form-group>
            <b-form-radio-group
              id="radios"
              name="radioSubComponent"
              v-model="isCarInvoicingRequired"
            >
              <b-form-radio value="2">{{$t('m.invoicingInfo.typeText1')}}</b-form-radio>
              <b-form-radio value="1">{{$t('m.invoicingInfo.typeText2')}}</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </li>
        <li>
          <strong>{{$t('m.invoicingInfo.nameTitle')}}</strong>
          <input type="text" :placeholder="$t('m.invoicingInfo.risePlaceholder')" v-model="bussinssName">
        </li>
        <li v-show="isCarInvoicingRequired=='2'">
          <strong>{{$t('m.invoicingInfo.numberTitle')}}</strong>
          <input type="text" :placeholder="$t('m.invoicingInfo.numberPlaceholder')" v-model="bussinssNumber">
        </li>
        <li>
          <strong>{{$t('m.invoicingInfo.contextTitle')}}</strong>
          <input :maxlength="64" type="text" v-model="content" disabled style="background-color:#fff">
        </li>
        <li>
          <strong>{{$t('m.invoicingInfo.moneyTitle')}}</strong>
          <input
            type="number"
            placeholder="0"
            disabled
            v-model="orderAmount"
            style="background-color:#fff;"
          >
        </li>
        <div class="invocingInfoTitle">{{$t('m.invoicingInfo.subtitle2')}}</div>
        <li>
          <strong>{{$t('m.invoicingInfo.emailTilte')}}</strong>
          <input type="email" :placeholder="$t('m.invoicingInfo.emailPlaceholder')" v-model="email">
        </li>
      </ul>
    </header>

    <footer>
      <b-button href="#" :disabled="bussinssName==''||email==''"  v-show="isCarInvoicingRequired=='1'">
        <span style="display: block;" @click="verification()">{{$t('m.invoicingInfo.button')}}</span>
      </b-button>
      <b-button href="#" :disabled="bussinssName==''||email==''||bussinssNumber==''"  v-show="isCarInvoicingRequired=='2'">
        <span style="display: block;" @click="verification()">{{$t('m.invoicingInfo.button')}}</span>
      </b-button>
    </footer>
    <!-- 电具电子发票   -->
    <b-modal
      ref="myModalRefs"
      centered
      :title="$t('m.invoicingInfo.modalTitle')"
      class="invoingInfo"
      :ok-title="$t('m.invoicingInfo.ok')"
      :cancel-title="$t('m.invoicingInfo.cancel')"
      @ok="submit()"
    >
      <ul>
        <li>
          <strong>{{$t('m.invoicingInfo.nameTitle')}}</strong>
          <span>{{bussinssName}}</span>
        </li>
        <li v-show="isCarInvoicingRequired=='2'">
          <strong>{{$t('m.invoicingInfo.numberTitle')}}</strong>
          <span>{{bussinssNumber}}</span>
        </li>
        <li>
          <strong>{{$t('m.invoicingInfo.moneyTitle')}}</strong>
          <span>{{orderAmount}}{{$t('m.invoicingInfo.CNY')}}</span>
        </li>
        <li>
          <strong>{{$t('m.invoicingInfo.emailTilte')}}</strong>
          <span>{{email}}</span>
        </li>
        <p>{{$t('m.invoicingInfo.tips')}}</p>
        <p v-show="isCarInvoicingRequired=='1'">{{$t('m.invoicingInfo.tips2')}}</p>
      </ul>
    </b-modal>
     <b-modal
      ref="myModalRef"
      id="messageBox"
      centered
      :ok-title="$t('m.phone.call')"
      :title="$t('m.phone.serviceTitle')"
      :cancel-title="$t('m.phone.cancel')"
      @ok="handleOk"
    >{{phone}}</b-modal>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
import { applyInvoice } from "../../api/invoice.js";

export default {
  name: "invoicingInfo",
  data() {
    return {
      isCarInvoicingRequired: 2, //控制类型
      orderId: [], //订单id
      type: "", //类型 1个人 2公司
      bussinssName: "", //发票抬头
      content:'', //发票内容
      email: "", //邮箱
      bussinssNumber: "", //税号
      orderAmount: "", //发票金额
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "", //提示类型
      phone: "400-115-0606", //手机号
      companyName:[],//企业名称
      parkingName:[],//车区名称
      parkingId:[],
      companyId:[]


    };
  },
  methods: {
    //验证是否为空和格式
    verification: function() {
      if (this.isCarInvoicingRequired == 2) {
        if (this.bussinssNumber == "" || this.bussinssNumber == null) {
          this.tipShow = "1" + Math.random() * 1000;
          this.message = this.$t('m.invoicingInfo.errorbussinssNumber');
          this.tipType = "error";
          return;
        } else if (
          !/^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/.test(
            this.bussinssNumber
          )
        ) {
          this.tipShow = "1" + Math.random() * 1000;
          this.message = this.$t('m.invoicingInfo.errorbussinssNumber');
          this.tipType = "error";
          return;
        }
      }
      if (
        !/^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/.test(this.email)) {
        this.tipShow = "1" + Math.random() * 1000;
        this.message = this.$t('m.invoicingInfo.errorEmail');
        this.tipType = "error";
        return;
      }

      this.$refs.myModalRefs.show();
    },
    //提交数据方法
    submit: function() {
      applyInvoice({
        orderIds: this.orderId,
        type: this.isCarInvoicingRequired,
        bussinssName: this.bussinssName,
        bussinssNumber: this.bussinssNumber,
        contents: this.content,
        email: this.email,
        companyId:this.companyId,
        parkingId:this.parkingId,
        companyName:this.companyName,//企业名称
        parkingName:this.parkingName//车区名称

      }).then(
        response => {
          if (response.data.status == 200) {
            this.$router.push("/invoiceCompletion");
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    }, call() {
      this.$refs.myModalRef.show();
    },
    handleOk: function() {
      window.location.href = "tel:" + this.phone;
    }
  },
  created() {
    this.orderId = this.$route.params.orderId; //订单Id
    this.companyName = this.$route.params.companyName
    this.parkingName = this.$route.params.parkingName;
    this.parkingId = this.$route.params.parkingId;
    this.companyId = this.$route.params.companyId;
    this.orderAmount = this.$route.params.orderAmount; //金额
    this.content=this.$t('m.invoicingInfo.contextText');
  }
};
</script>
<style>
.invoingInfo .modal-center .media-container {
  position: relative;
}
.modal-dialog {
  height: 100% !important;
}

.invoingInfo .modal-dialog {
  position: relative;
  margin: 0px;
}
.invoingInfo .modal-dialog .modal-content {
  top: 25% !important;
  bottom: 0px;
  margin: 0 auto;
  border-radius: 0px;
}
.invoingInfo .modal-dialog .modal-content ul {
  padding-inline-start: 0px;
}
.invoingInfo .modal-dialog .modal-content ul li {
  list-style: none;
  border-bottom: 1px solid #e7e7e7;
  padding: 4px 15px;
}
.invoingInfo .modal-dialog .modal-content .modal-header {
  width: 100%;
}
.invoingInfo .modal-dialog .modal-content .modal-body {
  padding-bottom: 0px;
}
.invoingInfo .modal-dialog .modal-content .modal-footer {
  border-top: 0px;
}
.invoingInfo .modal-dialog .modal-content ul li strong {
  font-size: 14px;
  font-family: "宋体";
  display: inline-block;
  float: left;
  padding-top: 5px;
  width: 20%;
  text-align: left;
  color: #5c5b5b;
}
.invoingInfo .modal-dialog .modal-content ul li span {
  text-align: left;
  display: inline-block;
  width: 72%;
  color: #2e2e2e;
}
.invoingInfo .modal-dialog .modal-content ul p {
  text-align: left;
  padding: 0 5px;
  font-size: 13px;
  margin-bottom: 0px;
}
</style>

<style scoped>
header {
  margin: 0 auto;
  padding: 0px;
}
header .warning .alert {
  margin-bottom: 0px;
  font-size: 13px;
  color: #504e4e;
  border-top: 1px solid #f8e0b3;
  border-bottom: 1px solid #f8e0b3;
  background-color: #f7e7c9;
  border-radius: 0;
}
header .invocingInfoTitle {
  background-color: #f5f5f5;
  color: #a7a5a0;
  font-size: 14px;
  text-align: left;
  padding-left: 15px;
  line-height: 33px;
}
header ul {
  padding-inline-start: 0px;
}
header ul li {
  list-style: none;
  border-bottom: 1px solid #e7e7e7;
  padding: 4px 15px;
}
header ul li strong {
  font-size: 14px;
  font-family: "宋体";
  display: inline-block;
  float: left;
  padding-top: 5px;
  width: 18%;
  text-align: left;
}
header ul li #radios {
  display: inline-block;
}
header ul li .b-form-group {
  display: inline-block;
  font-size: 13px;
  padding-top: 12px;
  margin-bottom: 8px;
}
header ul li .b-form-group .custom-control input {
  padding-bottom: 10px;
  margin-top: 10px;
  padding-top: 10px;
}
header ul li input {
  font-size: 14px;
  width: 74%;
  border: 0px;
  height: 30px;
}
footer {
  margin-top: 45px;
}
footer a {
  color: #fff;
  border: 0;
  background-color: #0066B1;
  /* background-color: #fff; */
  border-radius: 4px;
  line-height: 40px;
  width: 100%;
}
</style>
